import React from "react";
import "./assets/css/Loader.css";

// 👉 Import your logo
import logo from "./assets/images/apexologo.webp"; // update path if needed

function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>

      {/* Logo */}
      <img src={logo} alt="Apexo Industrial" className="loader-logo" />
    </div>
  );
}

export default Loader;